import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { updateSecurityStatus } from "../service/admin";
import { snackbar, loader } from "../../utils";

const SecurityStatusModal = ({
  isOpen,
  toggle,
  subscriberId,
  currentStatus,
  onSuccess,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(
    currentStatus || "Primary",
  );

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleSubmit = async () => {
    if (!subscriberId) {
      snackbar.error("Subscriber ID is required");
      return;
    }

    try {
      loader.start();
      const payload = {
        subscriberId: subscriberId,
        status: selectedStatus,
        Primary: selectedStatus === "Primary",
        Secondary: selectedStatus === "Secondary",
      };

      const response = await updateSecurityStatus(payload);

      if (response.data) {
        snackbar.success("Security status updated successfully!");
        if (onSuccess) {
          onSuccess();
        }
        toggle();
      }
    } catch (error) {
      console.error("Security status update error:", error);
      snackbar.error(
        error.response?.data?.message ||
          "Failed to update security status. Please try again.",
      );
    } finally {
      loader.stop();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Update Security Status</ModalHeader>
      <ModalBody>
        <div style={{ padding: "1rem" }}>
          <FormControl component="fieldset" fullWidth>
            <label
              style={{
                display: "block",
                marginBottom: "1rem",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Select Security Level:
            </label>
            <RadioGroup
              value={selectedStatus}
              onChange={handleStatusChange}
              style={{ marginBottom: "1.5rem" }}
            >
              <FormControlLabel
                value="Primary"
                control={<Radio color="primary" />}
                label={
                  <span style={{ fontSize: "0.95rem" }}>
                    <strong>Primary</strong>
                  </span>
                }
                style={{
                  padding: "0.5rem",
                  borderRadius: "8px",
                  border:
                    selectedStatus === "Primary"
                      ? "2px solid #1976d2"
                      : "2px solid transparent",
                  backgroundColor:
                    selectedStatus === "Primary" ? "#e3f2fd" : "transparent",
                }}
              />
              <FormControlLabel
                value="Secondary"
                control={<Radio color="primary" />}
                label={
                  <span style={{ fontSize: "0.95rem" }}>
                    <strong>Secondary</strong>
                  </span>
                }
                style={{
                  padding: "0.5rem",
                  borderRadius: "8px",
                  border:
                    selectedStatus === "Secondary"
                      ? "2px solid #1976d2"
                      : "2px solid transparent",
                  backgroundColor:
                    selectedStatus === "Secondary" ? "#e3f2fd" : "transparent",
                }}
              />
            </RadioGroup>
          </FormControl>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
              marginTop: "1.5rem",
            }}
          >
            <Button
              variant="outlined"
              onClick={toggle}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                color: "#666",
                borderColor: "#ddd",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Update Status
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SecurityStatusModal;
